import React from "react";
import { Eyebrow } from "@/components/Section";
import { SEO } from "@/components/SEO";

export const Impressum = () => (
  <div data-testid="impressum-page" className="max-w-4xl mx-auto px-6 sm:px-12 py-20 sm:py-28 bg-white">
    <SEO title="Impressum" description="Impressum von IT-Servicepoint, Ron Kowalewsky, Im Wiesengrund 2A, 36277 Schenklengsfeld." noindex />
    <Eyebrow>Impressum</Eyebrow>
    <h1 className="mt-6 font-display font-black text-4xl sm:text-5xl tracking-tightest text-ink">Impressum</h1>

    <div className="mt-12 space-y-8 text-muted leading-relaxed">
      <div>
        <h2 className="font-display font-bold text-xl text-ink mb-2">Angaben gemäß § 5 TMG</h2>
        <p>IT Servicepoint<br/>Ron Kowalewsky<br/>Im Wiesengrund 2A<br/>36277 Schenklengsfeld</p>
      </div>
      <div>
        <h2 className="font-display font-bold text-xl text-ink mb-2">Vertreten durch</h2>
        <p>Ron Kowalewsky</p>
      </div>
      <div>
        <h2 className="font-display font-bold text-xl text-ink mb-2">Kontakt</h2>
        <p>Telefon: 06629-9153890<br/>E-Mail: info@it-servicepoint.eu</p>
      </div>
      <div>
        <h2 className="font-display font-bold text-xl text-ink mb-2">Haftungsausschluss</h2>
        <p><strong className="text-ink">Haftung für Inhalte:</strong> Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen. Bei Bekanntwerden von Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
      </div>
      <div>
        <h2 className="font-display font-bold text-xl text-ink mb-2">Haftung für Links</h2>
        <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
      </div>
      <div>
        <h2 className="font-display font-bold text-xl text-ink mb-2">Urheberrecht</h2>
        <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
      </div>
    </div>
  </div>
);

export const Datenschutz = () => (
  <div data-testid="datenschutz-page" className="max-w-4xl mx-auto px-6 sm:px-12 py-20 sm:py-28 bg-white">
    <SEO title="Datenschutzerklärung" description="Datenschutzerklärung von IT-Servicepoint nach DSGVO." noindex />
    <Eyebrow>Datenschutz</Eyebrow>
    <h1 className="mt-6 font-display font-black text-4xl sm:text-5xl tracking-tightest text-ink">Datenschutzerklärung</h1>

    <div className="mt-12 space-y-8 text-muted leading-relaxed">
      <p>Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.</p>
      <p>Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.</p>
      <p>Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen.</p>
      <div>
        <h2 className="font-display font-bold text-xl text-ink mb-2">Cookies & Tracking</h2>
        <p>Diese Webseite verwendet ausschließlich technisch notwendige Cookies (z.B. für die Authentifizierung im Admin-Bereich). Es werden keine Tracking- oder Analyse-Tools eingesetzt, die personenbezogene Daten an Dritte übertragen.</p>
      </div>
      <div>
        <h2 className="font-display font-bold text-xl text-ink mb-2">Ihre Rechte nach DSGVO</h2>
        <ul className="space-y-2 list-disc pl-5">
          <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
        </ul>
        <p className="mt-4">Für Anfragen zum Datenschutz wenden Sie sich bitte an: info@it-servicepoint.eu</p>
      </div>
    </div>
  </div>
);
